import { pickThemeColor, pickThemeFontSize } from '@/theme';
import styled from 'styled-components';

export const StyledIcon = styled.span`
  .anticon {
    color: ${pickThemeColor('GREY')};
    font-size: ${pickThemeFontSize('20')};
  }
`;

export const StyedWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  flex-grow: 1;
`;

export const StyledList = styled.div`
  margin-top: 1rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;
